import React from "react";
import Select from "react-select";
import { ArrowDown01Icon } from "../../icons/icons";

export default function CreditHistorySelect({
  size,
  name,
  value,
  onChange,
  ariaLabel,
  label,
  style,
  staticOption,
  options,
  className,
  disabled,
}) {

  return (
    <Select
    className="credit-select"
    classNamePrefix="credit"
    styles={{
        control: (base) => ({
          ...base,
          width: "200px", 
        }),
        menu: (base) => ({
          ...base,
          width: "200px", // Fixed width for the dropdown menu
        }),
        menuPortal: (base) => ({
          ...base,
          zIndex: 9999, // Ensure it appears above everything
        }),
      }}
       components={{ DropdownIndicator: ArrowDown01Icon }}
    value={value}
    options={options}
    onChange={onChange}
    // menuIsOpen={true}
  />
  );
}

